<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>课程安排</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">

                <el-form-item label="课程名称">
                    <el-input v-model="listQuery.courseName" placeholder="" clearable></el-input>
                </el-form-item>
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="讲师">
                    <el-select v-model="listQuery.lecturerUserId" clearable placeholder="请选讲师" filterable>
                        <el-option v-for="(item,index) in lecturerList" :key="index" :label="item.lecturerName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  v-per="'kechenganpai'"  class="el-icon-plus" plan @click="addCourse">课程安排</el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="courseName" label="课程名称" width="120"></el-table-column>
                <el-table-column prop="lectureUserName" label="讲师" width="100"></el-table-column>
                <el-table-column prop="course.skillName" label="培训技能" width="120"></el-table-column>
                <el-table-column prop="address" label="上课地点"></el-table-column>
                <el-table-column prop="course.trainingContent" label="培训内容"></el-table-column>
                <el-table-column prop="startTime" label="上课时间">
                    <template slot-scope="scope">
                        {{formateTime(scope.row.startTime)}} 至 {{formateTime(scope.row.endTime)}}
                    </template>
                </el-table-column>

                <el-table-column prop="isDocumentary" label="是否跟单" width="100">
                    <template slot-scope="scope">
                       <span v-if="scope.row.isDocumentary==0">否</span>
                        <span style="color:blue;" v-if="scope.row.isDocumentary==1">无薪跟单</span>
                        <span style="color:green;" v-if="scope.row.isDocumentary==2">有薪跟单</span>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag type="success"  v-if="scope.row.state==0">开启</el-tag>
                         <el-tag type="danger" style="" v-if="scope.row.state==1">关闭</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>

                <el-table-column label="操作" fixed="right" width="250">
                    <template slot-scope="scope">
                         <el-button type="text" icon="el-icon-info" @click="gostudentTrain(scope.row)">查看学员</el-button>
                           <!-- <el-button type="primary"  v-per="'xueyuanbaokei'"   v-if="scope.row.state==0" plan @click="toaddStudy(scope.row)">学员报课</el-button> -->

                        <el-button type="text"  v-per="'xiugaikecheng'" icon="el-icon-edit"  v-if="scope.row.state==0" @click="handleEditStation( scope.row)">修改课程</el-button>
                        <el-button type="text"  v-per="'guanbikecheng'" icon="el-icon-delete"  v-if="scope.row.state==0" @click="handleDel(scope.$index, scope.row)">关闭课程</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog :title="addFrom.id?'修改课程安排':'添加课程安排'" :visible.sync="showAdd" width="600px" :close-on-click-modal="false" center>
            <el-form ref="addFrom" :model="addFrom" :rules="addRules" label-width="100px">
                <el-form-item label="课程" prop="courseId">
                    <el-select v-model="addFrom.courseId" clearable   placeholder="课程选择" filterable>
                        <el-option v-for="(item,index) in allCourseList" :key="index" :label="item.courseName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="讲师" prop="lecturerUserId">
                    <el-select v-model="addFrom.lecturerUserId" clearable   placeholder="讲师选择" filterable>
                        <el-option v-for="(item,index) in lecturerList" :key="index" :label="item.lecturerName" :value="item.userId+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="城市" prop="cityId">
                    <el-select v-model="addFrom.cityId" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="上课时间" prop="chooseDate">
                    <el-date-picker v-model="addFrom.chooseDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="{}"></el-date-picker>
                </el-form-item>
                <el-form-item label="上课地点" prop="address">
                    <el-input v-model="addFrom.address" placeholder="" style="width:400px;" clearable></el-input>
                </el-form-item>
                <el-form-item label="培训内容" prop="trainingContent">
                    <el-input v-model="addFrom.trainingContent" placeholder="" style="width:400px;" clearable></el-input>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="showAdd = false">关闭</el-button>
                <el-button type="primary" @click="saveCourse('addFrom')">提交</el-button>
            </span>
        </el-dialog>

         <!--创建订单 -->
        <studentTrainForm ref="studentTrainFormRef" />

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import studentTrainForm from "@/components/workercrm/compent/studentTrainForm.vue";
let vm;
export default {
    components: { Pagination,studentTrainForm },
    data() {
        return {
            courseType: {
                0: "准入培训",
                1: "其他",
                2: "管理培训",
                3: "技能提升",
            },
            isDocumentaryType: {
                0: "否",
                1: "无薪跟单",
                2: "有薪跟单",
            },
            listData: [],
            cityList: [],
            postStationList: [],
            allStationList: [],

            lecturerList: [], //讲师
            allCourseList: [], //课程

            skillList: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                courseName: null,
                cityId: null,
                lecturerUserId: null,
            },

            addFrom: {
                chooseDate: [],

                courseId: null,
                cityId: null,
                lecturerUserId: null,
                address: null,
                startTime: null,
                endTime: null,
            },
            addRules: {
                chooseDate: [
                    {
                        required: true,
                        message: "请选择上课时间",
                        trigger: "change",//blur
                    },
                ],
                courseId: [
                    {
                        required: true,
                        message: "请选择课程",
                        trigger: "change",
                    },
                ],
                cityId: [
                    {
                        required: true,
                        message: "请选择城市",
                        trigger: "change",
                    },
                ],
                lecturerUserId: [
                    {
                        required: true,
                        message: "请选择讲师",
                        trigger: "change",
                    },
                ],
                 address: [
                    {
                        required: true,
                        message: "请输入上课地址",
                        trigger: "blur",
                    },
                ],
                trainingContent:[
                    {
                        required: true,
                        message: "请输入培训内容",
                        trigger: "blur",
                    },
                ],
            },
            showUpdate: false,
            showAdd: false,
        };
    },

    created() {
        this.getAllCity();
        this.getAllPostStation();
        this.getAllStationList();

        this.getAllLecturer();
        this.getCourseGetAllCourseList();

        this.querySearch();
    },
    methods: {
         toaddStudy(row) {
            //添加学员
            this.$refs.studentTrainFormRef.toaddStudy(row.id);
        },
        gostudentTrain(row){
            //查看课程下报课的学员
            this.$router.push({
                path: "/workermanager/empowermentTrain/studentTrain",
                query: {
                    courseArrangementId: row.id,
                },
            });

        },
        handleDel(index, row) {
            this.$confirm("是否停用课程安排?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    crmApi
                        .$ajaxemCourseArrangementStopCourse({
                            id: row.id,
                            updateUserId: globalData.userInfo.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => {});
        },
        handleEditStation(row) {
            this.showAdd = true;
            this.addFrom = {
                id: row.id,
                chooseDate: [row.startTime, row.endTime],

                courseId: row.courseId+'',
                cityId: row.cityId+'',
                lecturerUserId: row.lecturerUserId+'',
                address: row.address,
                startTime: null,
                endTime: null,
                trainingContent:row.trainingContent
            };
        },
        addCourse() {
          if(true){
            this.$message.error('此功能已下线，请到学员培训菜单，操作学员报名');
            return;
          }
            this.showAdd = true;
            this.addFrom = {
                chooseDate: [],

                courseId: null,
                cityId: null,
                lecturerUserId: null,
                address: null,
                startTime: null,
                endTime: null,
                trainingContent:''

            };
        },

        saveCourse(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addFrom.startTime=this.addFrom.chooseDate[0];
                    this.addFrom.endTime=this.addFrom.chooseDate[1];

                    crmApi.$ajaxemCourseArrangementAdd(this.addFrom).then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("操作成功");
                            this.showAdd = false;
                            this.querySearch();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    });
                }
            });
        },

        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            this.listQuery.userId=globalData.userInfo.id;
            crmApi
                .$ajaxemCourseArrangementGetPageList(this.listQuery)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.listData = res.data.data.list;
                        this.total = res.data.data.total;
                    }
                });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity({userId:globalData.userInfo.id}).then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getAllPostStation() {
            //驿站
            crmApi.$axiosPostStationgetAllList().then((res) => {
                if (res.data.errno == 0) {
                    this.postStationList = res.data.data;
                }
            });
        },
        getAllStationList() {
            //服务站
            wmsApi.$axiosGetAllStationList().then((res) => {
                if (res.data.errno == 0) {
                    this.allStationList = res.data.data;
                }
            });
        },
        getAllLecturer() {
            //获取讲师下拉框
            crmApi.$ajaxEmCourseGetAllLecturer().then((res) => {
                if (res.data.errno == 0) {
                    this.lecturerList = res.data.data;
                }
            });
        },
        getCourseGetAllCourseList() {
            //获取讲师下拉框
            crmApi.$ajaxEmCourseGetAllCourseList().then((res) => {
                if (res.data.errno == 0) {
                    this.allCourseList = res.data.data;
                }
            });
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>
